import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('Attachment')
export class Attachment {
  @JsonProperty('id', String)
  public id?: string = undefined;

  @JsonProperty('attachmentId', String)
  public attachmentId?: string = undefined;

  @JsonProperty('filePath', String)
  public filePath?: string = undefined;

  @JsonProperty('fileName', String)
  public fileName?: string = undefined;

  @JsonProperty('fileSize', Number)
  public fileSize?: number = undefined;

  @JsonProperty('contentType', String)
  public contentType?: string = undefined;

  @JsonProperty('createdDate', String)
  public createdDate?: string = undefined;
}
